import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ReactDOM from "react-dom";
import {Button} from "antd";
import {LeftOutlined} from "@ant-design/icons";
import Spin from "../../custom/spin/Spin";
import AccountSettingActions from "../../action/accountsetting/AccountSettingActions";
import PasswordSettingModal from "./component/PasswordSettingModal";

function AccountSettingView({mainDataContext, dataContext, actions, onClose, style}) {
    const renderTitle = ({title, width}) => {
        return (
            <div style={{width}}>
                {title}
            </div>
        );
    };

    const renderContent = ({content, isMobile, width}) => {
        const isBind = !_.isEmpty(content);
        if (!isBind) {
            return (
                <div style={{fontSize: 14, color: "#90A4AD", width}}>
                    未绑定
                </div>
            );
        }
        if (isBind && isMobile) {
            content = `${content.substring(0, 3)}****${content.substring(7)}`;
        }

        return (
            <div style={{fontSize: 14, width}}>
                {content}
            </div>
        );
    };


    const renderButtons = ({isBind, isMobile, onBind, onCancelBind, onChangeBind}) => {
        if (!isBind) {
            return (
                <Button type="link" onClick={onBind} style={{padding: 0}}>绑定</Button>
            );
        } else {
            if (isMobile) {
                return (
                    <Button type="link" onClick={onChangeBind} style={{padding: 0}}>更换</Button>
                );
            } else {
                return (
                    <div style={{display: "flex", alignItems: "center"}}>
                        <Button type="link" style={{color: "red", marginRight: 10, padding: 0}} onClick={onCancelBind}>解绑</Button>
                        <Button type="link" style={{padding: 0}} onClick={onChangeBind}>更换</Button>
                    </div>
                );
            }
        }
    };


    return ReactDOM.createPortal(
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "#F3F6F8",
                display: "flex",
                flexFlow: "column nowrap",
                zIndex: 1000,
                ...style,
            }}
        >
            <Spin spinning={dataContext.loading} prefixCls="numas-spin">
                <div
                    style={{
                        height: 52,
                        display: "flex",
                        padding: "0 112px",
                        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
                        backgroundColor: "#FFF",
                        alignItems: "center",
                        zIndex: 1,
                    }}
                >
                    <Button
                        onClick={onClose}
                    >
                        <LeftOutlined />
                        <span>返回</span>
                    </Button>
                    <div style={{height: 18, width: 1, margin: "0 24px", background: "#D2D8DE"}} />
                </div>
                <div
                    style={{
                        display: "flex",
                        flexFlow: "column nowrap",
                        flex: 1,
                        padding: "12px 100px 16px 100px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            borderRadius: 5,
                            backgroundColor: "#FFF",
                            padding: 20,
                            overflow: "auto",
                            height: "100%",
                        }}
                    >
                        <div style={{fontSize: 16, fontWeight: "bold"}}>
                            账户设置
                        </div>
                        <div style={{display: "flex", flex: 1}}>
                            <div style={{width: 200, borderRight: "2px solid #f4f6f7", marginTop: 40}}>
                                <div style={{display: "flex", alignItems: "center", flexDirection: "column", marginTop: 30}}>
                                    {
                                        mainDataContext.user.avatar
                                            ? (
                                                <img style={{flex: "none", height: 80, width: 80, borderRadius: "50%", marginRight: 8, marginBottom: 20}}
                                                    src={decodeURI(mainDataContext.user.avatar)}
                                                />
                                            )
                                            : null
                                    }
                                    <div style={{flex: "none", fontSize: 14, fontWeight: "bold", marginBottom: 5}}>{mainDataContext.user.name}</div>
                                    <Button
                                        type="link"
                                        onClick={() => {
                                            actions.update({
                                                passwordSettingModalVisible: true,
                                            });
                                        }}
                                    
                                    
                                    >修改密码
                                    </Button>
                                </div>
                            </div>
                            <div style={{flex: 1, padding: 50}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    {renderTitle({title: "手机号码", width: 150})}
                                    {renderContent({
                                        content: mainDataContext.user.mobile,
                                        isMobile: true,
                                        width: 200,
                                    })}
                                    {renderButtons({
                                        isBind: !_.isEmpty(mainDataContext.user.mobile),
                                        isMobile: true,
                                        onBind: actions.onBindMobile,
                                        onCancelBind: actions.onCancelBindMobile,
                                        onChangeBind: actions.onChangeBindMobile,
                                    })}
                                </div>
                                <div style={{display: "flex", alignItems: "center", marginTop: 30}}>
                                    {renderTitle({title: "钉钉授权", width: 150})}
                                    {renderContent({
                                        content: mainDataContext.user?.ddUserId,
                                        isMobile: false,
                                        width: 200,
                                    })}
                                    {renderButtons({
                                        isBind: !_.isEmpty(mainDataContext.user?.ddUserId),
                                        isMobile: false,
                                        onBind: actions.onBindDD,
                                        onCancelBind: actions.onCancelBindDD,
                                        onChangeBind: actions.onChangeBindDD,
                                    })}
                                </div>
                                <div style={{display: "flex", alignItems: "center", marginTop: 30}}>
                                    {renderTitle({
                                        title: "企业微信授权",
                                        width: 150,
                                    })}
                                    {renderContent({
                                        content: mainDataContext.user?.wxUserId,
                                        isMobile: false,
                                        width: 200,
                                    })}
                                    {renderButtons({
                                        isBind: !_.isEmpty(mainDataContext.user?.wxUserId),
                                        isMobile: false,
                                        onBind: actions.onBindWX,
                                        onCancelBind: actions.onCancelBindWX,
                                        onChangeBind: actions.onChangeBindWX,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
            {
                dataContext.passwordSettingModalVisible && (
                    <PasswordSettingModal
                        onCancel={() => {
                            actions.update({
                                passwordSettingModalVisible: false,
                            });
                        }}
                    />
                )
            }
        </div>,
        document.body
    );
}


export default connect(
    state => ({
        dataContext: state.accountSetting.accountSettingViewModel,
        mainDataContext: state.mainViewModel,
    }),
    dispatch => ({
        actions: bindActionCreators(AccountSettingActions, dispatch),
    })
)(AccountSettingView);
